import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqFilters');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'channel_filters',
  type: 'get',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqFilters.js